import React from 'react';
import { WrapperHeader, StatusBarStyle } from './style';

export default function StatusBarHeaderConsult({ project }) {
  return (
    <WrapperHeader>
      <StatusBarStyle color="#C8CFF2">
        <p>
          Mês: <strong>{project.monthName}</strong>
        </p>
      </StatusBarStyle>
      <StatusBarStyle color="#FEFFD8">
        <p>
          Ano Fiscal: <strong>{project.year}</strong>
        </p>
      </StatusBarStyle>
      <StatusBarStyle color={project.status ? '#DAFFFB' : '#FFE6D8'}>
        <p>
          Status: <strong>{project.status ? 'Concluído' : 'Incompleto'}</strong>
        </p>
      </StatusBarStyle>
      <StatusBarStyle color="#EAFFDA">
        <p>
          Valor total do mês:{' '}
          <strong>{project.totalValue.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</strong>
        </p>
      </StatusBarStyle>
      <StatusBarStyle color="#FFE6D8">
        <p>
          Rateio Total:<strong> {project.totalRateio}%</strong>
        </p>
      </StatusBarStyle>
      <StatusBarStyle color="#D8FFFD">
        <p>
          Valor Total:{' '}
          <strong>{project.totalValueStatus.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</strong>
        </p>
      </StatusBarStyle>
      <StatusBarStyle color="#F7FEC9">
        <p>
          Itens anexados? - <strong>{project.links.length === 0 ? 'NÃO' : `${project.links.length} anexo(s)`}</strong>
        </p>
      </StatusBarStyle>
      <StatusBarStyle color="#E1DAFF">
        <p>
          Sincroniza Educação (26.837.644/0001-22):{' '}
          <strong>{project.totalValueCnpj1.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</strong>
        </p>
      </StatusBarStyle>
      <StatusBarStyle color="#DAFFF6">
        <p>
          Sincroniza Projetos (40.780.036/0001-50):{' '}
          <strong>{project.totalValueCnpj2.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</strong>
        </p>
      </StatusBarStyle>
    </WrapperHeader>
  );
}
